import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConsultaHistoricoMigradoService } from "../../servicios/consulta-historico-migrado.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { Config, ConsultaHistoricoMigrado, ConsultaHistoricoMigradoInput } from "../../entidades/entidades";

@Component({
  selector: "app-consulta-historico-migrado-grid",
  templateUrl: "./consulta-historico-migrado-grid.component.html",
  styleUrls: ["./consulta-historico-migrado-grid.component.css"],
})
export class ConsultaHistoricoMigradoGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  consultaHistoricoMigrado: ConsultaHistoricoMigrado[];
  historicoMigrado: ConsultaHistoricoMigrado;
  historico: ConsultaHistoricoMigrado;
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedConsultaHistoricoMigrado: { [s: string]: ConsultaHistoricoMigrado } = {};
  totalRecords: number;

  saldoAnterior = 0.0; saldoFinal = 0.0; saldoPeriodo = 0.0;

  idAmbiente: number;

  @Input("consultaHistoricoMigradoInput" ) consultaHistoricoMigradoInput: ConsultaHistoricoMigrado;
  @Input("cantidadBimestres") cantidadBimestres: ConsultaHistoricoMigradoInput;
  @Output("consultaHistoricoMigrado") consultaHistoricoMigradoOutput: EventEmitter<ConsultaHistoricoMigrado>;

  constructor(
    private consultaHistoricoMigradoService: ConsultaHistoricoMigradoService,
  ) { }

  ngOnInit(): void {

    //let config: Config = JSON.parse(localStorage.getItem("config"));
    //this.consultaHistoricoMigradoInput.idAmbiente = config.IdAmbiente;

    if (this.consultaHistoricoMigradoInput) {
      console.log("RETORNA DATOS: ", this.consultaHistoricoMigradoInput);
      this.getAllConsultaHistoricoMigrado();
    }

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      { label: "Refrescar", icon: "pi pi-refresh", command: (event) => { this.getAllConsultaHistoricoMigrado(); } },
    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      // { field: "id", header: "id", ordenar: true, styleHeader: "width: 100px;", },
      { field: "fecha", header: "Fecha", ordenar: true, styleHeader: "width: 100px;", },
      { field: "perioDePago", header: "Periodo pagado", ordenar: true, styleHeader: "width: 150px;", },
      { field: "foliocobro", header: "Folio", ordenar: true, styleHeader: "width: 100px;", },
      { field: "serie", header: "Serie", ordenar: true, styleHeader: "width: 100px;", },
      { field: "importecobrado", header: "Total", ordenar: true, styleHeader: "width: 90px;", },
      { field: "iva", header: "IVA", ordenar: true, styleHeader: "width: 70px;", },
      { field: "subtotal", header: "Sub Total", ordenar: true, styleHeader: "width: 100px;", },
      { field: "aguaCorriente", header: "Agua", ordenar: true, styleHeader: "width: 100px;", },
      { field: "aguacorreinteDescuento", header: "Agua Desc", ordenar: true, styleHeader: "width: 100px;", },
      { field: "drenajecorriente", header: "Drenaje", ordenar: true, styleHeader: "width: 100px;", },
      { field: "drenajecorrienteDescuento", header: "Drenaje Desc", ordenar: true, styleHeader: "width: 100px;", },
      { field: "saneamientocorriente", header: "Sane", ordenar: true, styleHeader: "width: 100px;", },
      { field: "saneamientocorrienteDescuento", header: "Sane Desc", ordenar: true, styleHeader: "width: 100px;", },
      { field: "infraestructuraCorriente", header: "Infraestructura", ordenar: true, styleHeader: "width: 120px;", },
      { field: "recargos", header: "Recargos", ordenar: true, styleHeader: "width: 100px;", },
      { field: "recargosDesc", header: "Rec Desc", ordenar: true, styleHeader: "width: 100px;", },
      { field: "abonoSaldo", header: "Abono Sal", ordenar: true, styleHeader: "width: 100px;", },
      { field: "otrocobros", header: "Otros", ordenar: true, styleHeader: "width: 100px;", },
      { field: "realizo", header: "Realizo", ordenar: true, styleHeader: "width: 350px;", },
      { field: "ofina", header: "Oficina", ordenar: true, styleHeader: "width: 300px;", },
      { field: "serieCfd", header: "Serie CFDI", ordenar: true, styleHeader: "width: 100px;", },
      { field: "folioCfd", header: "Folio CFDI", ordenar: true, styleHeader: "width: 100px;", },
     
    ];
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {
    // let consultaHistoricoMigradoNew = new ConsultaHistoricoMigrado();
    // consultaHistoricoMigradoNew.cambio = true;
    // consultaHistoricoMigradoNew.id = 0;
    // consultaHistoricoMigradoNew.numRow = this.consultaHistoricoMigrado.length + 1;
    // this.consultaHistoricoMigrado.unshift(consultaHistoricoMigradoNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    // let consultaHistoricoMigradoEdit = event.data;
    // this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow] = { ...consultaHistoricoMigradoEdit };
    // consultaHistoricoMigradoEdit.cambio = true;
    // consultaHistoricoMigradoEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    // let consultaHistoricoMigradoEdit = event.data;
    // let index = this.consultaHistoricoMigrado.findIndex(
    //   (obj) => obj.numRow === consultaHistoricoMigradoEdit.numRow
    // );
    // this.consultaHistoricoMigrado[index] = { ...this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow] };
  }

  // prettier-ignore
  onDelete(event, index: number) {
    // event.cambio = false;
    // event.baja = true;
  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let consultaHistoricoMigradoEdit = event.data;

      //Valida si hay cambios
      // if (
      //   consultaHistoricoMigradoEdit.id === this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow].id &&
      //   consultaHistoricoMigradoEdit.numerocuenta === this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow].numerocuenta &&
      //   consultaHistoricoMigradoEdit.numeroderivada === this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow].numeroderivada &&
      //   consultaHistoricoMigradoEdit.factura === this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow].factura &&
      //   consultaHistoricoMigradoEdit.periodoabsoluto === this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow].periodoabsoluto &&
      //   consultaHistoricoMigradoEdit.anio === this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow].anio &&
      //   consultaHistoricoMigradoEdit.bimestre === this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow].bimestre &&
      //   consultaHistoricoMigradoEdit.consumofacturado === this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow].consumofacturado &&
      //   consultaHistoricoMigradoEdit.estado === this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow].estado &&
      //   consultaHistoricoMigradoEdit.saldoanterior === this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow].saldoanterior &&
      //   consultaHistoricoMigradoEdit.saldoperiodo === this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow].saldoperiodo &&
      //   consultaHistoricoMigradoEdit.saldofinal === this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow].saldofinal &&
      //   consultaHistoricoMigradoEdit.pagado === this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow].pagado
         
      // ) {
      //   let index = this.consultaHistoricoMigrado.findIndex((obj) => obj.numRow === consultaHistoricoMigradoEdit.numRow);
      //   this.consultaHistoricoMigrado[index] = { ...this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoEdit.numRow] };
      //   return;
      // }

      // //Validaciones
      // throw new Error("No paso las validaciones.");

      // consultaHistoricoMigradoEdit.cambio = true;
      // consultaHistoricoMigradoEdit.baja = false;
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarGridConsultaHistoricoMigrado() {
    try {
      // for (let consultaHistoricoMigradoFor of this.consultaHistoricoMigrado) {
      //   if (consultaHistoricoMigradoFor.baja) {
      //     await this.deleteConsultaHistoricoMigrado(consultaHistoricoMigradoFor);
      //   } else if (consultaHistoricoMigradoFor.cambio) {
      //     consultaHistoricoMigradoFor.cambio = false;
      //     this.clonedConsultaHistoricoMigrado[consultaHistoricoMigradoFor.id] = { ...consultaHistoricoMigradoFor, };
      //     if (consultaHistoricoMigradoFor.id === 0) {
      //       const datoRetorno = await this.addConsultaHistoricoMigrado(consultaHistoricoMigradoFor);
      //       consultaHistoricoMigradoFor.id = datoRetorno.id;
      //     } else {
      //       await this.updateConsultaHistoricoMigrado(consultaHistoricoMigradoFor);
      //     }
      //   }
      // }

      // this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarConsultaHistoricoMigrado");
    }
  }

  // prettier-ignore
  async addConsultaHistoricoMigrado(consultaHistoricoMigrado) {
    try {
      // const datoretorno = await this.consultaHistoricoMigradoService
      //   .add(consultaHistoricoMigrado)
      //   .toPromise();
      // return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addConsultaHistoricoMigrado");
    }
  }

  // prettier-ignore
  async getAllConsultaHistoricoMigrado() {
    try {
      var historicoMigradoClone = new Array();
      var historicoMigradoNoDuplicados = new Array();
      var historicoMigradoCincoAnios = new Array();

      this.historicoMigrado = this.consultaHistoricoMigradoInput;
      this.totalRecords = this.historicoMigrado[0].length
        console.log('this.historicoMigrado:',  this.historicoMigrado)
      // for (var i = 0; i < Object.keys(this.historicoMigrado).length; i++) {
      //   //Sacamos solo los que no estan pagados
      //   if (this.historicoMigrado[i].pagado != 1) {
      //     historicoMigradoClone.push({
      //       "anio": this.historicoMigrado[i].anio,
      //       "bimestre": this.historicoMigrado[i].bimestre,
      //       "consumofacturado": this.historicoMigrado[i].consumofacturado,
      //       "estado": this.historicoMigrado[i].estado,
      //       "factura": this.historicoMigrado[i].factura,
      //       "id": this.historicoMigrado[i].id,
      //       "numerocuenta": this.historicoMigrado[i].numerocuenta,
      //       "numeroderivada": this.historicoMigrado[i].numeroderivada,
      //       "pagado": this.historicoMigrado[i].pagado,
      //       "periodoabsoluto": this.historicoMigrado[i].periodoabsoluto,
      //       "saldoanterior": this.historicoMigrado[i].saldoanterior,
      //       "saldofinal": this.historicoMigrado[i].saldofinal,
      //       "saldoperiodo": this.historicoMigrado[i].saldoperiodo,
      //     });
      //   }
      // }

      // /// Ordena el object por bimestre y año
      // if (Object.keys(historicoMigradoClone).length > 0) {
      //   historicoMigradoClone.sort(function (a, b) {
      //     return b.bimestre - a.bimestre;
      //   });
      //   historicoMigradoClone.sort(function (a, b) {
      //     return b.anio - a.anio;
      //   });
      // }

      // //Quitar duplicados
      // for (var i = 0; i < Object.keys(historicoMigradoClone).length - 1; i++) {
      //   if (historicoMigradoClone[i].anio == historicoMigradoClone[i + 1].anio) {
      //     if (historicoMigradoClone[i].bimestre != historicoMigradoClone[i + 1].bimestre) {
      //       historicoMigradoNoDuplicados.push({
      //         "anio": historicoMigradoClone[i].anio,
      //         "bimestre": historicoMigradoClone[i].bimestre,
      //         "consumofacturado": historicoMigradoClone[i].consumofacturado,
      //         "estado": historicoMigradoClone[i].estado,
      //         "factura": historicoMigradoClone[i].factura,
      //         "id": historicoMigradoClone[i].id,
      //         "numerocuenta": this.historicoMigrado[i].numerocuenta,
      //         "numeroderivada": historicoMigradoClone[i].numeroderivada,
      //         "pagado": historicoMigradoClone[i].pagado,
      //         "periodoabsoluto": historicoMigradoClone[i].periodoabsoluto,
      //         "saldoanterior": historicoMigradoClone[i].saldoanterior,
      //         "saldofinal": historicoMigradoClone[i].saldofinal,
      //         "saldoperiodo": historicoMigradoClone[i].saldoperiodo,
      //       });
      //     }

      //     if (historicoMigradoClone[i].bimestre == historicoMigradoClone[i + 1].bimestre && i + 2 == Object.keys(historicoMigradoClone).length) {
      //       historicoMigradoNoDuplicados.push({
      //         "anio": historicoMigradoClone[i].anio,
      //         "bimestre": historicoMigradoClone[i].bimestre,
      //         "consumofacturado": historicoMigradoClone[i].consumofacturado,
      //         "estado": historicoMigradoClone[i].estado,
      //         "factura": historicoMigradoClone[i].factura,
      //         "id": historicoMigradoClone[i].id,
      //         "numerocuenta": this.historicoMigrado[i].numerocuenta,
      //         "numeroderivada": historicoMigradoClone[i].numeroderivada,
      //         "pagado": historicoMigradoClone[i].pagado,
      //         "periodoabsoluto": historicoMigradoClone[i].periodoabsoluto,
      //         "saldoanterior": historicoMigradoClone[i].saldoanterior,
      //         "saldofinal": historicoMigradoClone[i].saldofinal,
      //         "saldoperiodo": historicoMigradoClone[i].saldoperiodo,
      //       });

      //     }
      //   }
      //   else if (historicoMigradoClone[i].anio != historicoMigradoClone[i + 1].anio) {
      //     historicoMigradoNoDuplicados.push({
      //       "anio": historicoMigradoClone[i].anio,
      //       "bimestre": historicoMigradoClone[i].bimestre,
      //       "consumofacturado": historicoMigradoClone[i].consumofacturado,
      //       "estado": historicoMigradoClone[i].estado,
      //       "factura": historicoMigradoClone[i].factura,
      //       "id": historicoMigradoClone[i].id,
      //       "numerocuenta": this.historicoMigrado[i].numerocuenta,
      //       "numeroderivada": historicoMigradoClone[i].numeroderivada,
      //       "pagado": historicoMigradoClone[i].pagado,
      //       "periodoabsoluto": historicoMigradoClone[i].periodoabsoluto,
      //       "saldoanterior": historicoMigradoClone[i].saldoanterior,
      //       "saldofinal": historicoMigradoClone[i].saldofinal,
      //       "saldoperiodo": historicoMigradoClone[i].saldoperiodo,
      //     });
      //   }
      // }

    //  var faltaBimestre = parseInt(localStorage.getItem('totalABimestresOutput'));
      //this.saldoFinal = parseInt(localStorage.getItem('totalBimestres'));
      
      // faltaBimestre = 30 - faltaBimestre;

      // //Obtiene solo los ultimos 30 bimestres
      // for (var x = 0; x < faltaBimestre; x++) {

      //   historicoMigradoCincoAnios.push({
      //     "anio": historicoMigradoNoDuplicados[x].anio,
      //     "bimestre": historicoMigradoNoDuplicados[x].bimestre,
      //     "consumofacturado": historicoMigradoNoDuplicados[x].consumofacturado,
      //     "estado": historicoMigradoNoDuplicados[x].estado,
      //     "factura": historicoMigradoNoDuplicados[x].factura,
      //     "id": historicoMigradoNoDuplicados[x].id,
      //     "numerocuenta": historicoMigradoNoDuplicados[x].numerocuenta,
      //     "numeroderivada": historicoMigradoNoDuplicados[x].numeroderivada,
      //     "pagado": historicoMigradoNoDuplicados[x].pagado,
      //     "periodoabsoluto": historicoMigradoNoDuplicados[x].periodoabsoluto,
      //     "saldoanterior": historicoMigradoNoDuplicados[x].saldoanterior,
      //     "saldofinal": historicoMigradoNoDuplicados[x].saldofinal,
      //     "saldoperiodo": historicoMigradoNoDuplicados[x].saldoperiodo,
      //   });
      //  // this.saldoFinal += historicoMigradoCincoAnios[x].saldofinal;
      // }

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllConsultaHistoricoMigrado");
    }
  }

  // prettier-ignore
  async updateConsultaHistoricoMigrado(consultaHistoricoMigrado: ConsultaHistoricoMigrado) {
    try {
      // const datoRetorno = await this.consultaHistoricoMigradoService
      //   .update(consultaHistoricoMigrado)
      //   .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateConsultaHistoricoMigrado");
    }
  }

  // prettier-ignore
  async deleteConsultaHistoricoMigrado(consultaHistoricoMigrado: ConsultaHistoricoMigrado) {
    try {
      // const datoRetorno = await this.consultaHistoricoMigradoService
      //   .delete(consultaHistoricoMigrado.id)
      //   .toPromise();
      // this.getAllConsultaHistoricoMigrado();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteConsultaHistoricoMigrado");
    }
  }
}